import BaseRadio from './Radio';

// EXPORT
export const Radio = BaseRadio;
export type { RadioProps } from './Radio.interface';
